import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles(() => ({
    tableRoot: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
    },
    tableContainer: {
        flexGrow: 1,
    },
    tableBodyRow: {
        cursor: 'pointer',
    },
    pageInput: {
        width: '150px',
    },
    colorButtonBack: {
        backgroundColor: '#0066CC',
        color: 'white',
        borderRadius: '0px',
        marginTop: '1rem',
    },
}));
